import { ListView } from 'modules/Listings/components/ListView/ListView';
import { ENTITY_SLUGS, ListingsStateProvider, useListingStore } from 'modules/Listings/store/StateContext';
import { withListLayout } from 'modules/Listings/withListLayout';
import { FC, useCallback, useEffect, useMemo } from 'react';
import { BreadcrumbJsonLd } from 'next-seo';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { modulesListType } from 'modules/Listings/store/Store.types';
import { createModulesList } from 'modules/Modules/listingStore/createModulesList';
import { useQueryClient } from 'react-query';
import { buildCommunityBreadcrumbs } from 'utils/breadcrumbs';
import { getDefautServerProps } from 'server/getDefaultServerProps';
import { FILTER_ID } from 'modules/Listings/components/AllStarTemplateToggle';

export const ModulesPage: FC<{
  host: string;
  initialQuery: Record<string, string>;
}> = ({ host }) => {
  const router = useRouter();
  const query = router.query as Record<string, string>;
  const queryClient = useQueryClient();

  const modulesStore = useListingStore<modulesListType>(
    useCallback(
      () =>
        createModulesList({
          queryClient,
          userId: undefined,
          initialList: [],
          isStarred: query?.activeToggle === FILTER_ID.STARRED,
          initialQuery: query,
        }),
      [],
    ),
    [],
  );

  useEffect(() => {
    modulesStore.load();
  }, [modulesStore]);

  // instantiating inside component so ListingsStateProvider can give state to search, filters etc.
  const ListWithLayout = useMemo(() => withListLayout(ListView, false), []);

  return (
    <ListingsStateProvider store={modulesStore} entityType={ENTITY_SLUGS.modules}>
      <BreadcrumbJsonLd itemListElements={buildCommunityBreadcrumbs({ host, page: 'modules' })} />
      <ListWithLayout
        pageName="modules_page"
        title="Do more with AI using UI modules"
        heading="Create AI solutions by combining task specific UI modules into your applications to do more."
        requestLinkText="Request Module"
      />
    </ListingsStateProvider>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ params, req, res }) => {
  const host = req ? req.headers.host : 'clarifai.com';
  const defautServerProps = await getDefautServerProps({ params, req, res });
  return {
    props: {
      ...defautServerProps,
      host,
      trackEventProps: {
        eventName: 'Community Modules Page Viewed',
      },
      seoProps: {
        title: 'Do more with AI using UI modules',
        description: 'Create AI solutions by combining task specific UI modules into your applications to do more.',
      },
    },
  };
};

export default ModulesPage;
